import selections from '../util';
import common from './common';

export default { ...selections(common) };
